import './overrides.scss'

export const preset = {
  breakpoint: {
    thresholds: {
      xs: 375 + 16,
      sm: 546 + 16,
      md: 1024 + 16,
      lg: 1365 + 16,
    },
  },
  icons: {
    iconfont: 'mdi',
    values: {
      expand: 'mdi-menu-right',
    },
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#4E4E4E',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#38BE56',
        warning: '#FFC107',
      },
    },
  },
}
